import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { inr } from "@/lib/api";

export const AdminSubscriptions = () => {
  const [data, setData] = useState({ restaurants: [], payments: [] });
  useEffect(() => { api.get("/admin/subscriptions").then(({ data }) => setData(data)); }, []);

  const restById = Object.fromEntries(data.restaurants.map((r) => [r.id, r]));

  return (
    <div data-testid="admin-subscriptions">
      <h1 className="text-2xl font-bold">Subscriptions & Payments</h1>
      <p className="text-sm text-zq-muted mt-1">All payment activity across restaurants.</p>

      <h2 className="font-semibold mt-7 mb-3">Restaurant subscriptions</h2>
      <div className="zq-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-zq-orange-light text-left">
            <tr>
              <th className="p-3">Restaurant</th>
              <th className="p-3">Plan</th>
              <th className="p-3">Status</th>
              <th className="p-3">Started</th>
            </tr>
          </thead>
          <tbody>
            {data.restaurants.map((r) => (
              <tr key={r.id} className="border-t border-zq-border">
                <td className="p-3 font-medium">{r.name}</td>
                <td className="p-3 capitalize">{r.plan}</td>
                <td className="p-3">
                  <span className={`zq-pill ${r.suspended ? "zq-pill-gray" : "zq-pill-green"}`}>{r.suspended ? "Suspended" : "Active"}</span>
                </td>
                <td className="p-3 text-xs">{new Date(r.created_at).toLocaleDateString("en-IN")}</td>
              </tr>
            ))}
            {data.restaurants.length === 0 && (
              <tr><td colSpan={4} className="p-6 text-center text-zq-muted">No restaurants.</td></tr>
            )}
          </tbody>
        </table>
      </div>

      <h2 className="font-semibold mt-8 mb-3">Razorpay payments</h2>
      <div className="zq-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-zq-orange-light text-left">
            <tr>
              <th className="p-3">Order ID</th>
              <th className="p-3">Restaurant</th>
              <th className="p-3">Plan</th>
              <th className="p-3">Setup</th>
              <th className="p-3">Plan Fee</th>
              <th className="p-3">Total</th>
              <th className="p-3">Type</th>
              <th className="p-3">Date</th>
            </tr>
          </thead>
          <tbody>
            {data.payments.map((p) => (
              <tr key={p.id} className="border-t border-zq-border">
                <td className="p-3 font-mono text-xs">{p.razorpay_order_id}</td>
                <td className="p-3">{restById[p.restaurant_id]?.name || "—"}</td>
                <td className="p-3 capitalize">{p.plan}</td>
                <td className="p-3">{inr(p.setup_fee)}</td>
                <td className="p-3">{inr(p.plan_fee)}</td>
                <td className="p-3 font-semibold">{inr(p.amount)}</td>
                <td className="p-3"><span className={`zq-pill ${p.is_renewal ? "zq-pill-orange" : "zq-pill-green"}`}>{p.is_renewal ? "Renewal" : "First"}</span></td>
                <td className="p-3 text-xs">{new Date(p.created_at).toLocaleDateString("en-IN")}</td>
              </tr>
            ))}
            {data.payments.length === 0 && (
              <tr><td colSpan={8} className="p-6 text-center text-zq-muted">No payments yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
